import { datadogRum } from '@datadog/browser-rum';
import { BaseDDConfig, configure, Env } from '@prenuvo/nimbus-logger';
import { DD_APP_ID, DD_SERVICE_NAME, DD_TOKEN, STAGE } from '../config';
import { standardizeEnv } from './env';
import { logConfig, Logger, rumConfig } from './logger-config';
import appConfig from '../../../package.json';

const environment = STAGE === 'local' ? 'loc' : STAGE;
const env: Env = standardizeEnv(environment);

const baseConfig = {
  appId: DD_APP_ID,
  env: env,
  service: DD_SERVICE_NAME,
  token: DD_TOKEN,
  version: appConfig.version,
};

const getLogger = (name: string, baseConfigObj: BaseDDConfig) => {
  const logLevel = baseConfigObj.env === 'loc' ? 'debug' : 'info';

  return configure(name, logLevel, baseConfigObj, {
    logConfig,
    rumConfig,
  });
};

export const logger: Logger = getLogger('OBv3', baseConfig as BaseDDConfig);

export const datadogRumInit = () => {
  logger.info('Initializing the logger');

  datadogRum.init({
    applicationId: baseConfig.appId,
    clientToken: baseConfig.token,
    service: baseConfig.service,
    env: environment,
    version: baseConfig.version,
    ...rumConfig,
  });
};
